import Modal from 'components/Modal';
import { useTheme } from 'providers/ThemeProvider';
import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import IntlHelper from 'utils/helpers/intl.helper';

const GoAheadModal = () => {
  const t = IntlHelper.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);
  const { isDarkMode } = useTheme();
  const handleConfirm = () => {
    modalProps.value ? modalProps.func(modalProps.value) : modalProps.func();
  };

  return (
    <>
      <Modal.Header
        title={t('go_ahead')}
        subtitle={modalProps.subtitle ? t(`subtitle_${modalProps.subtitle}`) : t('modifiche_non_salvate')}
      />
      <Modal.Footer
        confirmText={t('continua')}
        confirmAction={handleConfirm}
        closeButtonText={t('annulla')}
        dontCloseOnConfirm={modalProps.dontCloseModal}
        scopeSecondary={isDarkMode ? 'quaternary' : 'secondary'}
      />
    </>
  );
};

export default GoAheadModal;
